module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"create":"Создание статьи"}}')
  delete Component.options._Ctor
}
